import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataOptimizeDateDtoModelBase } from './PlanningActionMetadataOptimizeDateDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataOptimizeDateDtoModel */
export interface PlanningActionMetadataOptimizeDateDtoModelType extends Instance<typeof PlanningActionMetadataOptimizeDateDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataOptimizeDateDtoModel */
export {
  selectFromPlanningActionMetadataOptimizeDateDto, planningActionMetadataOptimizeDateDtoModelPrimitives, PlanningActionMetadataOptimizeDateDtoModelSelector,
} from './PlanningActionMetadataOptimizeDateDtoModel.base';

/**
 * PlanningActionMetadataOptimizeDateDtoModel
 */
export const PlanningActionMetadataOptimizeDateDtoModel = PlanningActionMetadataOptimizeDateDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
